const BASE_URL = process.env.REACT_APP_STUDENTLOGIN_BASE_URL;
const EPICENTER_BASE_URL = process.env.REACT_APP_EPICENTERAPI_BASE_URL;
const CY_SSO_BASE_URL = process.env.REACT_APP_SSO_BASE_URL;

export { BASE_URL, EPICENTER_BASE_URL, CY_SSO_BASE_URL };
